import React from 'react';
import { Row, Col, Typography } from 'antd';
import Barcode from 'react-barcode';
import aurikshaLogo from '../../../assets/auriksha_logo.png';
import companyInfo from '../../../jsons/companyInfo.json';

const { Title, Text } = Typography;

const CompanyInfo = ({ billDate, billId }) => {
  return (
    <Row justify="space-between" align="middle" style={{ marginBottom: 20 }}>
      <Col>
        <div style={{ textAlign: 'left' }}>
          <img
            src={aurikshaLogo}
            alt="Company Logo"
            style={{ width: '150px', marginBottom: '10px' }}
          />
          <Title level={5} style={{ margin: 0 }}>{companyInfo.name}</Title>
          <div><Text>{companyInfo.cin}</Text></div>
          <>
              { <div><Text>{companyInfo.addressLine1} {companyInfo.addressLine2}</Text></div>}
              { <div><Text>{companyInfo.addressLine3}</Text></div>}
            </>
          
          <div><Text>{companyInfo.phone}{companyInfo.email ? ` • ${companyInfo.email}` : ''}</Text></div>
        </div>
      </Col>

      <Col>
        <div style={{ textAlign: 'right' }}>
          <Title level={5} style={{ marginBottom: 4 }}>
            Invoice Date: {billDate ? new Date(billDate).toLocaleDateString() : 'N/A'}
          </Title>
          <Title level={5} style={{ marginBottom: 8 }}>
            Id: {billId}
          </Title>
          <Barcode value={billId} width={1.2} height={30} displayValue fontSize={10} />
        </div>
      </Col>
    </Row>
  );
};

export default CompanyInfo;
